import React from 'react';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

import Typography from './Typography';

// TODO cleanup styles for `atoms/EmptyState`
const styles = ({ spacing: { unit }, palette: { text } }: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'transparent',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      fontSize: 50,
      lineHeight: 1,
    },
    title: {
      marginTop: unit * 2,
      fontWeight: 600,
    },
    content: {
      color: text.secondary,
      textAlign: 'center',
      fontWeight: 500,
      fontSize: 16,
    },
  });

export interface EmptyStateProps extends WithStyles<typeof styles>, React.HTMLAttributes<HTMLDivElement> {
  icon: string;
  title: string;
  subtitle?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ classes, className, icon, title, subtitle, children, ...rest }) => (
  <div className={classnames(classes.root, className)} {...rest}>
    <span className={classes.icon}>{icon}</span>
    <Typography className={classes.title} variant="h5" color="primary" paragraph={!subtitle} gutterBottom={!!subtitle}>
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body1LargeBold" color="primary" paragraph={!children}>
        {subtitle}
      </Typography>
    )}
    {children && <div className={classes.content}>{children}</div>}
  </div>
);

export default withStyles(styles)(EmptyState);
